import { Link } from "react-router-dom";
import { brand } from "../lib/brand";

export function TermsPage() {
  return (
    <main className="legal-page">
      <Link to="/dashboard">← กลับ</Link>
      <h1>เงื่อนไขการใช้บริการ</h1>
      <p className="legal-meta">ปรับปรุงล่าสุด: 2026-05-05</p>

      <p>
        การเข้าใช้งาน {brand.name} ถือว่าคุณยอมรับเงื่อนไขด้านล่าง
        หากคุณไม่ยอมรับ กรุณาหยุดใช้งาน
      </p>

      <h2>1. บริการของเรา</h2>
      <p>
        {brand.name} ให้บริการคอร์สเรียนออนไลน์แบบบันทึกล่วงหน้า (pre-recorded)
        ซื้อครั้งเดียว ดูได้ตลอดอายุของระบบ
      </p>

      <h2>2. บัญชีผู้ใช้</h2>
      <ul>
        <li>หนึ่งบัญชีต่อหนึ่งคน: ห้ามแชร์อีเมล/บัญชีกับผู้อื่น</li>
        <li>คุณรับผิดชอบในความปลอดภัยของอีเมลที่ใช้ login</li>
        <li>หากเราตรวจพบการแชร์บัญชี อาจระงับการเข้าใช้งานโดยไม่คืนเงิน</li>
      </ul>

      <h2>3. การชำระเงิน</h2>
      <ul>
        <li>ชำระผ่าน Stripe: เก็บเงินครั้งเดียวต่อคอร์ส</li>
        <li>ราคาแสดงในหน้าขายเป็นราคาสุทธิ (รวม VAT แล้วหากมี)</li>
        <li>หลังชำระสำเร็จ ระบบจะส่งอีเมลยืนยันพร้อมลิงก์เข้าสู่คอร์ส</li>
      </ul>

      <h2>4. นโยบายคืนเงิน</h2>
      <p>
        ขอ refund ได้ภายใน 7 วันหลังซื้อ โดยทักผ่าน Facebook Messenger
        หากดำเนินการ refund แล้ว สิทธิ์เข้าคอร์สจะถูกถอดออกอัตโนมัติ
      </p>

      <h2>5. ทรัพย์สินทางปัญญา</h2>
      <p>
        เนื้อหาทั้งหมด (วิดีโอ, เอกสาร, ภาพ) เป็นลิขสิทธิ์ของ {brand.name}
        ห้ามคัดลอก เผยแพร่ซ้ำ หรือใช้ในเชิงพาณิชย์โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษร
        การละเมิดอาจถูกดำเนินคดีตามกฎหมาย
      </p>

      <h2>6. ความรับผิด</h2>
      <p>
        เราจะดูแลให้บริการทำงานตามปกติ แต่ไม่รับประกันว่าระบบจะใช้งานได้ 100% ตลอดเวลา
        ในกรณีระบบมีปัญหา เราจะแก้ไขโดยเร็วที่สุด
        ความรับผิดสูงสุดของเราจำกัดอยู่ที่ราคาของคอร์สที่คุณซื้อ
      </p>

      <h2>7. การยกเลิกบริการ</h2>
      <p>
        เราขอสงวนสิทธิ์ระงับ/ยกเลิกบัญชีหากพบการละเมิดเงื่อนไข
        คุณสามารถลบบัญชีของตัวเองได้ทุกเมื่อในหน้า /profile
      </p>

      <h2>8. การเปลี่ยนแปลงเงื่อนไข</h2>
      <p>
        เงื่อนไขอาจมีการแก้ไข เราจะแจ้งให้ทราบล่วงหน้าผ่านอีเมล
        การใช้งานต่อหลังการแก้ไขถือว่ายอมรับเงื่อนไขใหม่
      </p>

      <h2>9. กฎหมายที่ใช้บังคับ</h2>
      <p>
        เงื่อนไขนี้อยู่ภายใต้กฎหมายไทย ข้อพิพาทใด ๆ ให้ใช้ศาลในเขตกรุงเทพมหานครเป็นเขตอำนาจ
      </p>

      <h2>10. ติดต่อเรา</h2>
      <p>
        อีเมล: <a href={`mailto:${brand.contactEmail}`}>{brand.contactEmail}</a>
      </p>
    </main>
  );
}
